import {kmApiLink, Scenario} from "@pg-mono/km-routes";

import {kmApi} from "../../km_app/api/km_api";
import {IVariables} from "../../km_app/state/variables_slice";
import {GetRegionDetailsDto} from "../types/GetRegionDetailsDto";
import {getAllRegionTypesFromVariable} from "../utils/get_all_region_types_from_variable";

interface IRegionsResponse {
    results: GetRegionDetailsDto[];
}

const SEARCH_REGIONS_LIMIT = 30;

export const regionsApi = kmApi.injectEndpoints({
    endpoints: (build) => ({
        getRegions: build.query<IRegionsResponse, {regionIds: number[]}>({
            queryFn: async (params, {getState}, _extraOptions, baseQuery) => {
                const allRegionTypeValues = getAllRegionTypesFromVariable(getState() as {variables: IVariables});

                const response = await baseQuery({
                    url: kmApiLink.regions.base(Scenario.REGION_DETAIL),
                    params: {
                        region: params.regionIds,
                        type: allRegionTypeValues,
                        page_size: SEARCH_REGIONS_LIMIT
                    }
                });

                if (response.error) {
                    return {
                        error: response.error
                    };
                }

                return {
                    data: response.data as IRegionsResponse
                };
            }
        })
    })
});

export const {useGetRegionsQuery} = regionsApi;
import {kmApiLink, Scenario} from "@pg-mono/km-routes";

import {kmApi} from "../../km_app/api/km_api";
import {IVariables} from "../../km_app/state/variables_slice";
import {GetRegionDetailsDto} from "../types/GetRegionDetailsDto";
import {getAllRegionTypesFromVariable} from "../utils/get_all_region_types_from_variable";

interface IRegionsResponse {
    results: GetRegionDetailsDto[];
}

const SEARCH_REGIONS_LIMIT = 30;

export const regionsApi = kmApi.injectEndpoints({
    endpoints: (build) => ({
        getRegions: build.query<IRegionsResponse, {regionIds: number[]}>({
            queryFn: async (params, {getState}, _extraOptions, baseQuery) => {
                const allRegionTypeValues = getAllRegionTypesFromVariable(getState() as {variables: IVariables});

                const response = await baseQuery({
                    url: kmApiLink.regions.base(Scenario.REGION_DETAIL),
                    params: {
                        region: params.regionIds,
                        type: allRegionTypeValues,
                        page_size: SEARCH_REGIONS_LIMIT
                    }
                });

                if (response.error) {
                    return {
                        error: response.error
                    };
                }

                return {
                    data: response.data as IRegionsResponse
                };
            }
        })
    })
});

export const {useGetRegionsQuery} = regionsApi;
